import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useScrollFade } from '../hooks/useScrollFade';
export function FAQSection() {
  const {
    ref,
    isVisible
  } = useScrollFade();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Does RF Microneedling hurt?',
    answer: 'We prioritize your comfort. Before the treatment, we apply a medical-grade topical numbing cream. Most patients describe the sensation as a mild prickling or warmth. It is highly tolerable, and we adjust the settings to ensure you remain comfortable throughout the session.'
  }, {
    question: 'How is this different from regular microneedling?',
    answer: 'While traditional microneedling creates micro-injuries to stimulate healing, RF Microneedling adds radiofrequency energy. This energy travels down the needles deep into the dermis, creating a much stronger collagen-building response. It tightens and lifts in ways regular microneedling cannot.'
  }, {
    question: 'When will I see results?',
    answer: "You may notice an initial glow within a few days, but the real magic happens beneath the surface. As your body builds new collagen, you'll see progressive tightening and smoothing starting around 4 weeks, with peak results at 12 weeks."
  }, {
    question: 'How many sessions do I need?',
    answer: "For optimal, long-lasting results, we typically recommend a series of 3 to 4 sessions spaced 4 to 6 weeks apart. During your free consultation, we'll create a customized plan based on your specific skin goals."
  }, {
    question: 'Can I combine this with other treatments?',
    answer: "Absolutely. RF Microneedling pairs beautifully with other regenerative treatments. However, timing is important. We'll discuss your current regimen during your consultation to ensure we sequence treatments safely for the best possible outcome."
  }];
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 bg-white relative" data-id="element-94">
      <div className="container mx-auto px-4 md:px-8 max-w-3xl" data-id="element-95">
        <div ref={ref} className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-96">
          <h2 className="font-serif text-3xl md:text-4xl text-text-dark text-center mb-16" data-id="element-97">
            Frequently Asked Questions
          </h2>

          <div className="border-t border-divider" data-id="element-98">
            {faqs.map((faq, index) => <div key={index} className="border-b border-divider" data-id="element-99">
                <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" onClick={() => toggleAccordion(index)} aria-expanded={openIndex === index} data-id="element-100">
                  <span className="font-serif text-lg md:text-xl text-text-dark group-hover:text-gold transition-colors pr-8" data-id="element-101">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`text-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-102" />
                </button>
                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-103">
                  <p className="text-text-dark/70 leading-relaxed" data-id="element-104">
                    {faq.answer}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}